module.exports={
  "name": "@dabapps/roe",
  "version": "0.8.2",
  "description": "A Collection of React Components for Project Development",
  "main": "dist/js/index.js",
  "types": "dist/js/index.d.ts",
  "scripts": {
    "start": "./scripts/start",
    "build": "./scripts/build",
    "dist": "./scripts/dist",
    "lint-js": "tslint --project tsconfig.json --type-check '@(src|tests|types|docs)/**/*.@(ts|tsx)'",
    "lint-less": "lesshint 'src/less/' 'docs/src/less/'",
    "lint": "npm run lint-js && npm run lint-less",
    "tests": "jest",
    "test": "npm run lint && npm run tests -- --coverage",
    "postinstall": "./scripts/dist"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/dabapps/roe.git"
  },
  "keywords": [
    "pdk",
    "project",
    "development",
    "kit",
    "react",
    "components"
  ],
  "publishConfig": {
    "access": "restricted"
  },
  "author": "DabApps",
  "license": "BSD-3-Clause",
  "bugs": {
    "url": "https://github.com/dabapps/roe/issues"
  },
  "homepage": "https://github.com/dabapps/roe#readme",
  "dependencies": {
    "@types/classnames": "2.2.0",
    "@types/random-seed": "0.3.2",
    "@types/react": "15.0.22",
    "@types/react-dom": "15.5.0",
    "@types/react-transition-group": "1.1.0",
    "autoprefixer": "6.7.7",
    "browserify": "14.3.0",
    "classnames": "2.2.5",
    "exorcist": "0.4.0",
    "less": "2.7.2",
    "normalize.css": "6.0.0",
    "postcss": "5.2.17",
    "postcss-cli": "3.2.0",
    "random-seed": "0.3.0",
    "react": "15.5.4",
    "react-dom": "15.5.4",
    "react-transition-group": "1.1.3",
    "tsify": "3.0.1",
    "typescript": "2.3.3"
  },
  "devDependencies": {
    "@types/jest": "19.2.3",
    "@types/node": "7.0.13",
    "@types/react-test-renderer": "15.4.5",
    "brfs": "1.4.3",
    "concurrently": "3.4.0",
    "envify": "4.0.0",
    "http-server": "0.9.0",
    "jest": "20.0.3",
    "lesshint": "3.3.1",
    "livereload": "0.6.2",
    "react-test-renderer": "15.5.4",
    "ts-jest": "20.0.3",
    "tslint": "5.5.0",
    "tslint-config-dabapps": "github:dabapps/tslint-config-dabapps#v0.2.0",
    "watch-less-do-more": "0.2.0",
    "watchify": "3.9.0"
  },
  "peerDependencies": {
    "react": ">= 15 < 16",
    "react-dom": ">= 15 < 16",
    "react-transition-group": ">= 1 < 2",
    "typescript": ">= 2.3.3 < 3"
  },
  "jest": {
    "coverageThreshold": {
      "global": {
        "branches": 100,
        "functions": 100,
        "lines": 100,
        "statements": 100
      }
    },
    "transform": {
      "^.+\\.tsx?$": "<rootDir>/node_modules/ts-jest/preprocessor.js"
    },
    "testRegex": "(/tests/.*|\\.(test|spec))\\.(ts|tsx|js|jsx)$",
    "moduleFileExtensions": [
      "ts",
      "tsx",
      "js",
      "jsx"
    ],
    "mapCoverage": true
  }
}
